export default __webpack_public_path__ + "7f18185338132c9a6095a15bdb21c08a.svg";